<!--
 * @Author: your name
 * @Date: 2021-08-05 15:37:41
 * @LastEditTime: 2021-09-24 21:24:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /b_c_i18n/src/components/CurAddress/indexH5.vue
-->
<template>
  <div class="cur-address-h5">
    <DrawerDialog
      :loading="loading"
      @closeH5Dialog="closeH5Dialog"
      v-model="shows"
      :showInput="showInput"
      :title="title"
      :inputVal.sync="inputVals"
    >
      <slot></slot>
    </DrawerDialog>
  </div>
</template>
<script>
import DrawerDialog from '../DrawerDialog';
export default {
  components: {
    DrawerDialog,
  },
  props: {
    title: {
      type: String,
      default: 'Address',
      required: false,
    },
    showInput: {
      type: Boolean,
      default: true,
    },
    h5Visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    inputVal: {
      type: String,
      default: '',
      required: false,
    },
  },
  model: {
    prop: 'h5Visible',
    event: 'showsChange',
  },
  computed: {
    shows: {
      get: function() {
        return this.h5Visible;
      },
      set: function(value) {
        this.$emit('showsChange', value);
      },
    },
  },
  watch: {
    inputVals(newV) {
      this.$emit('update:inputVal', newV);
    },
  },
  data() {
    return {
      inputVals: '',
    };
  },
  methods:{
    closeH5Dialog() {
      this.$emit('closeH5Dialog');
    },
  }
};
</script>
<style lang="scss" scoped>
.cur-address-h5 {
  // margin-bottom: rem(40);
  .current-address__content {
    padding-bottom: 0;
  }
}
</style>
